import Alert from '@mui/material/Alert'
import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { dismissAlert, selectAlertsByArea } from '@/redux/reducers/alerts.reducer'

type AlertsPortalProps = {
  area: string
}

export function AlertsPortal({ area }: AlertsPortalProps) {
  const dispatch = useAppDispatch()
  const alerts = useAppSelector((state) => selectAlertsByArea(state, area))

  return (
    <>
      {alerts.map((alert) => (
        <Alert key={alert.id} severity={alert.type} onClose={() => dispatch(dismissAlert({ area: area, alertId: alert.id }))} variant="filled">
          {alert.message}
        </Alert>
      ))}
    </>
  )
}
